<template>
    <div class="col-12" :id="endpoint.name" >
        <h3>Service: {{endpoint.name}}</h3>
        <api-endpoint-route v-for="(route, key) in endpoint.data"
                            :endpointName="endpoint.name + key"
                            :key="route[key]"
                            :route="route"/>
    </div>
</template>
<script>
import ApiEndpointRoute from './ApiEndpointRoute';
/**
 * @module ApiBrowser
 * @description component used to display endpoints for a service
 * */
export default {
    name: 'api-endpoint',
    components: {ApiEndpointRoute},
    props: {
        endpoint: {}
    }
};
</script>
